import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLanguage } from '../../contexts/LanguageContext';
import './Layout.css';

const Layout = ({ children }) => {
    const { direction } = useLanguage();

    return (
        <div className={`layout layout--${direction}`} dir={direction}>
            <Header />
            <main className="layout__main animate-fade-in">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
